var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuantity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6799 10.1922H15.1671V6.46129H18.898V3.97404H15.1671V0.243164H12.6799V3.97404H8.94902V6.46129H12.6799V10.1922ZM7.7054 21.3848C6.33741 21.3848 5.23059 22.504 5.23059 23.872C5.23059 25.24 6.33741 26.3593 7.7054 26.3593C9.07339 26.3593 10.1926 25.24 10.1926 23.872C10.1926 22.504 9.07339 21.3848 7.7054 21.3848ZM20.1416 21.3848C18.7737 21.3848 17.6668 22.504 17.6668 23.872C17.6668 25.24 18.7737 26.3593 20.1416 26.3593C21.5096 26.3593 22.6289 25.24 22.6289 23.872C22.6289 22.504 21.5096 21.3848 20.1416 21.3848ZM9.07339 15.1667H18.3384C19.2711 15.1667 20.0919 14.6568 20.5147 13.8857L25.3151 5.16792L23.1512 3.97404L18.3384 12.6794H9.60814L4.3103 1.48679H0.243652V3.97404H2.7309L7.20795 13.4131L5.52906 16.4476C4.62121 18.114 5.81509 20.1412 7.7054 20.1412H22.6289V17.6539H7.7054L9.07339 15.1667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantity);
export default __webpack_public_path__ + "static/media/quantity.6158c3c8b70fff6f6d721cbc685d073a.svg";
export { ForwardRef as ReactComponent };